import { cn } from "cn"

// CUSTOMIZED: Fill is gray-300 — muted is too quiet for the first breath to read.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-gray-300", className)}
      {...props}
    />
  )
}

export { Skeleton }
